import { render } from "./good-list.vue?vue&type=template&id=18a7e49e&scoped=true"
import script from "./good-list.vue?vue&type=script&lang=js"
export * from "./good-list.vue?vue&type=script&lang=js"

import "./good-list.vue?vue&type=style&index=0&id=18a7e49e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-18a7e49e"

export default script